<div class="ttt">
<div *ngFor="let groupe of data" class="page">

  <table style="width:100%; border-collapse:collapse;">
    <tr>
      <!-- Logo gauche -->
      <td style="width:30%; text-align:center;">
        <img src="/assets/iseahz.png" alt="ISEAHZ" style="max-height:80px;"><br>
        <span>Nom et prénom(s): {{groupe.teacher?.first_name}} {{groupe.teacher?.last_name}}</span>
      </td>

      <!-- Logo centre -->
      <td style="width:40%; text-align:center;">
        <img src="/assets/univt.jpg" alt="Université de Tunis" style="max-height:80px;"><br>
        <span>Grade: {{groupe.teacher?.teacher_grade?.designation}}</span>
      </td>

      <!-- Infos année à droite -->
      <td style="width:30%; text-align:right; vertical-align:top;">
        <div style="font-weight:bold;">
          Année universitaire: 2025-2026<br>
          SEMESTRE {{division}}
        </div>
        <br>
        <table border="1" style="border-collapse:collapse; font-size:13px; width:100%;">
          <tr>
            <td colspan="2" style="text-align:center; font-weight:bold;">Heures effectives</td>
            <td style="text-align:center; font-weight:bold;">Heures converties</td>
          </tr>
          <tr>
            <td style="width:70px;">Cours</td>
            <td style="width:40px; text-align:center;">{{groupe.c ? groupe.c*1 : ''}}</td>
            <td rowspan="3" style="text-align:center;"></td>
          </tr>
          <tr>
            <td>T.D.</td>
            <td style="text-align:center;">{{groupe.td|| groupe.c ? (groupe.td*1.5)+(groupe.c ? groupe.c*0.5 : 0) : ''}}</td>
          </tr>
          <tr>
            <td>T.P.</td>
            <td style="text-align:center;">{{groupe.tp ? groupe.tp*1.5 : ''}}</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>


        <div class="row" >
           
         
            <div class="col-md-12 ">


                        <div class="schedule-table" id="emploi">
                            <table class="table bg-white" style="zoom: 0.8;">


                                <thead>

                                    <tr>
                                        <th></th>
                                            <th *ngFor="let period of periods ; let j = index" style="font-size: 12pt;"   class="{{j == 2 ?'bright' : ''}}">

                                                <!-- {{period.start_hour}} - {{period.end_hour}} -->
                                             
                                              <span *ngIf="period.start_hour == '08:30:00'"> 08:30</span>
                                              <span *ngIf="period.start_hour == '10:00:00'"> 10:00</span>
                                              <span *ngIf="period.start_hour == '12:30:00'"> 12:30</span>
                                              <span *ngIf="period.start_hour == '14:00:00'"> 14:00</span>
                                              <span *ngIf="period.start_hour == '15:30:00'"> 15:30</span>
                                              -

                                              <span *ngIf="period.end_hour == '10:00:00'"> 10:00</span>
                                              <span *ngIf="period.end_hour == '11:30:00'"> 11:30</span>
                                              <span *ngIf="period.end_hour == '14:00:00'"> 14:00</span>
                                              <span *ngIf="period.end_hour == '15:30:00'"> 15:30</span>
                                              <span *ngIf="period.end_hour == '17:00:00'"> 17:00</span>


                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let line of groupe.timetable ">
                                            <td class="day  " style="width: 4%;"><p style="min-height: 90px;">{{ line.abbreviation }}</p></td>

                                            <ng-container *ngFor="let col of line.days ; let j =index">
                                                <td *ngIf="col.period_id != break_id"  style="width: 16%;" class="active {{j == 2 ?'bright' : ''}}">
                                                  <ng-container *ngFor="let seance of col.seances">
                                                    <div class="div_seance
                                                    {{seance.subject_type.abbreviation == 'C' ? 'cours' : seance.subject_type.abbreviation == 'TD' ? 'td' : 'tp'}}"

                                                    style="position:relative;padding: 15px" [style.width]="seance.next && seance.next > 1 ? '190%' : 'unset' " [style.display]="seance.related_id ? 'none' : 'block'">


                                                    <div
                                                        style="position: absolute;top: 0;right: 0;background: #666 !important;padding: 10px;  color: white; font-weight: 600;">
                                                        {{ seance.subject_type?.abbreviation}}
                                                    </div>
                                                    <h4 style="margin-right: 22px;">
                                                        {{ seance.subject?.abbreviation }}

                                                        <!-- <span *ngIf="seance.subject_type.abbreviation == 'TP'" style="color: red; font-weight: 600;"> &nbsp; (
                                                          <span *ngIf="seance.period && seance.period.start_hour == '11:45:00'">12:15 {{seance.next && seance.next >1 ? ' - 15:15' : '13:45'}}</span>
                                                          <span *ngIf="seance.period && seance.period.start_hour == '08:30:00'">08:30 {{seance.next && seance.next >1 ? ' - 11h30' : '10:00'}}</span>
                                                          <span *ngIf="seance.period && seance.period.start_hour == '15:15:00'">15:30 {{seance.next && seance.next >1 ? ' - 18:30' : '17:00'}}</span>

                                                          <span *ngIf="seance.period && seance.period.start_hour == '10:15:00'">10:15 {{seance.next && seance.next >1 ? ' - 15:15' : '11:45'}}</span>
                                                          <span *ngIf="seance.period && seance.period.start_hour == '14:00:00'">14:00 {{seance.next && seance.next >1 ? ' - 17h00' : '15:30'}}</span>

                                                        </span> -->


                                                      </h4>


                                                        <span class="specific"  *ngIf="seance.start_hour != seance.period.start_hour || seance.end_hour != seance.period.end_hour">

                                                         <span >  ({{ seance.start_hour }} -
                                                            {{ seance.end_hour }})</span>
                                                          

                                                          </span>

                                                    <p>{{ seance.classroom?.abbreviation }} |
                                                        {{ seance.week_name }}  -
                                                            
                                                            <span *ngIf="seance.section">&nbsp;{{ seance.section?.abbreviation }}</span>
                                                            <span *ngIf="seance.group_td">&nbsp;{{ seance.group_td?.abbreviation }}</span>

                                                            <span *ngIf="seance.group_tp">&nbsp;{{ seance.group_tp?.abbreviation }}</span>
                                                        
                                                        
                                                        </p>



                                                </div>
                                                  </ng-container>

                                                </td>
                                                </ng-container>
                                        </tr>


                                </tbody>
                            </table>
                        </div>


            </div>
        </div>


</div>
</div>
